import config from '../../config/customer.api'
import { Request } from '../shared/base.requests'

const commonModule = {
  namespaced: true,
  state: {
    settings: null,
    contact: null,
    modifiableContact: null,
    attachment: null,
    perils: null,
    content: null,
    paymentMethods: null,
    homeImages: [],
    logo: '',
    phone: '',
    purchasedVehiclesCount: 0,
    companyMainImage: '',
    salesPersonFullName: '',
    salesTitle: '',
    salesPersonIcon: '',
    companyName: '',
    companyPhone: '',
    isFirstOpenApp: false,
    salesBio: '',
    email: '',
    salesSite: null,
    firstLoad: true,
    customButtons: [],
    salesCustomerAppId: 0,
    industryId: 0,
    inventoryId: 0,
    slsPermission: {webSite: false, blog: false, inventory: false, reviews: false, vipTestDrive: false, recommendAFriend: false},
    salesClass: null,
    customization: {
      defaultPresetId: null,
      fontColor: '#fff',
      // homePageMenuId: 0,
      iconColor: '#FFFFFF',
      mainColor: '#fff',
      navMenuId: 2,
      borderColor: '',
      borderOn: false
    },
    deletedInfo: null,
    dealerDisclaimer: ''
  },
  mutations: {
    fisrtLoadHomePage (state) {
      state.firstLoad = false
    },
    setHomePageSetting (state, payload) {
      state.logo = payload.logo
      state.phone = payload.phone
      state.companyMainImage = payload.companyHomePage
      state.salesPersonFullName = payload.salesPersonFullName
      state.salesTitle = payload.salesTitle
      state.salesPersonIcon = payload.salesPersonIcon
      state.companyName = payload.companyName
      state.salesCustomerAppId = payload.salesCustomerAppId
      state.companyPhone = payload.companyPhone
      state.salesBio = payload.salesBio
      state.email = payload.email
      state.salesSite = payload.salesSite
      state.slsPermission = payload.permission
      state.customButtons = payload.customIcons
      state.industryId = payload.industryId
      state.inventoryId = payload.inventoryId
      state.salesClass = payload.salesClass
      state.homeImages = payload.homeSlides
      state.customization = payload.customization
      state.purchasedVehiclesCount = payload.purchasedVehiclesCount
      state.salesGlobalId = payload.globalId
      state.dealerDisclaimer = payload.dealerDisclaimer || ''
    },
    setFirstOpenApp (state, payload) {
      state.isFirstOpenApp = payload
    },
    setDeletedInfo (state, payload) {
      state.deletedInfo = payload
    }
  },
  actions: {
    loadHomePageSettings: function getRemoteSettingsPromise (context) {
      if (localStorage.token) {
        return new Promise((resolve, reject) => {
          Request.GetFromCache(config.getHomePageSettings, function (json) {
            context.commit('setHomePageSetting', json.model)
            resolve({
              isDealerDeleted: json.model.dealerIsDeleted,
              isSalesPersonDeleted: json.model.salesPersonIsDeleted
            })
          })
          Request.get(config.getHomePageSettings)
            .then(function (response) {
              if (!response.success) { return }
              context.commit('setHomePageSetting', response.model)
              context.dispatch('about/setAboutData', response.model.about, { root: true })
              resolve({
                isDealerDeleted: response.model.dealerIsDeleted,
                isSalesPersonDeleted: response.model.salesPersonIsDeleted
              })
            })
            .catch(error => {
              console.error('getHomePageSettings failed', error)
              reject()
            })
        })
      }
    },
    setFirstOpenApp (context) {
      localStorage.setItem('OpenDate', new Date())
      Request.get(config.logCustomerActivity + 'openApp')
      context.commit('setFirstOpenApp', true)
    },
    setFirstLoaded (context) {
      context.commit('fisrtLoadHomePage')
    },
    getDeletedInfo (context) {
      return new Promise((resolve) => {
        Request.get(config.getDeletedInfo).then((response) => {
          context.commit('setDeletedInfo', response.model)
          resolve(false)
        })
      })
    }
  },
  getters: {
    getHomePageLogo: state => {
      return state.logo
    },
    getHomePagePhone: state => {
      return state.phone
    },
    getMeetTheTeamButtonTitle: state => {
      var title = state.customButtons.find(x => x.iconId === 178)
      if (title) {
        return title.text
      }
      return 'Meet the team'
    },
    customButtons: state => {
      return state.customButtons
      // TEST only
      // var l = state.customButtons
      // let menu = l.map((x, i) => {
      //   x.children = []
      //   if (i === 0) {
      //     // eslint-disable-next-line standard/computed-property-even-spacing
      //     x.children = [{...x, children: [].concat(l[state.customButtons.length - 1 ])}]
      //   }
      //   return x
      // })
      // console.warn('MENU:', menu)
      // return menu
    },
    deletedInfo: state => {
      return state.deletedInfo
    }
  }
}

export default commonModule



// WEBPACK FOOTER //
// ./scripts/src/store/common.module.js